import React from 'react';
import styles from './SocialLinks.module.scss';

export default function SocialLinks({ url, icon, label }) {
  return (
    <a href={`${url}`} aria-label={`Visit our ${label}`} className={`${styles.nav_link_bottom} p-1`}>
      <i aria-hidden="true"></i>
      <span className={`d-inline ${styles.label}`}>{icon}</span>
    </a>
  );
}
